import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { SubjectModel } from '@shared/models/subject.model';
import { SecurityService } from '@shared/services/security.service';
import { UsuarioService } from 'app/modules/security/service/usuario.service';

@Component({
  selector: 'header-user',
  template: `
    <nz-dropdown nzPlacement="bottomRight" nzTrigger="click">
      <div class="alain-default__nav-item d-flex align-items-center px-sm" nz-dropdown>
        <img alt="Menu" src="./assets/img/brand/opts-user.svg">
      </div>
      <div nz-menu class="width-sm">
        <div nz-menu-item (click)="showModal(password)">
          <i nz-icon type="lock" class="mr-sm"></i>
          {{ 'general.buttons.change_password' | translate }}
        </div>
        <li nz-menu-divider></li>
        <div nz-menu-item (click)="logout()">
          <i nz-icon type="logout" class="mr-sm"></i>
          {{ 'layout.header.menu.account.logout' | translate }}
        </div>
      </div>
    </nz-dropdown>

    <nz-modal
      #modal
      [nzVisible]="resetPasswordVisible"
      (nzOnCancel)="showModal(password)"
      (nzOnOk)="resetPassword(password)"
      [nzOkText]="'security.usuario.change_password.buttons.change' | translate"
    >
      <app-password-reset #password></app-password-reset>
    </nz-modal>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderUserComponent {
  subject: SubjectModel;
  resetPasswordVisible = false;

  constructor(private security: SecurityService, private router: Router, private userService: UsuarioService) {
    this.subject = this.security.subject;
  }

  logout() {
    sessionStorage.removeItem('tabData');
    this.router.navigate(['/auth/login']);
  }

  resetPassword(passwordModal) {
    const value = passwordModal.getValue();
    if (!value) return;

    this.showModal(passwordModal);
    const { senhaAtual, novaSenha } = value;
    this.userService.resetPassword({ senhaAtual, novaSenha }, this.subject.username).subscribe();
  }

  showModal(modal: any) {
    this.resetPasswordVisible = !this.resetPasswordVisible;
    modal.reset();
  }
}
